import { render } from "./MobileLayoutView.vue?vue&type=template&id=ed991860"
import script from "./MobileLayoutView.vue?vue&type=script&lang=js"
export * from "./MobileLayoutView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-webapp/frontend-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__